<template>
  <form>
    <div class="date_area clearfix">
      <div class="date_block clearfix">
        <div class="heading_title">
          駐診日期
        </div>
        <div class="select_area">
          <form-row>
            <form-group>
              <input-group>
                <form-select
                  :options="dates"
                  name="date_select"
                  @change="appointmentDateSelected"
                />
              </input-group>
            </form-group>
          </form-row>
        </div>
      </div>
      <div class="date_block clearfix">
        <div class="heading_title">
          選擇時段
        </div>
        <div class="select_area">
          <form-row>
            <form-group>
              <input-group>
                <form-select
                  :options="times"
                  name="time_select"
                  @change="appointmentTimeSlotSelected"
                />
              </input-group>
            </form-group>
          </form-row>
        </div>
      </div>
      <div v-if="show_status" class="date_block clearfix">
        <div class="heading_title">
          活動狀態
        </div>
        <div class="check_text" :class="{full: students_count >= limit}">
          <span>{{ students_count }}/{{ limit }}</span>(已報名/總名額)
        </div>
      </div>
    </div>

    <div class="consulting_project_area">
      <div class="title_block clearfix">
        <div class="heading_title">
          報名時段
        </div>
        <div class="check_text">
          {{ resident_start_date | moment("YYYY/MM/DD HH:mm") }} ~ {{ resident_end_date | moment("YYYY/MM/DD HH:mm")  }}
        </div>
      </div>
    </div>

    <div class="consulting_project_area">
      <div class="title_block clearfix">
        <div class="heading_title">
          諮詢項目
        </div>
        <div class="check_text">
          已選擇 {{ appointment.appointment_services.length }} 項
        </div>
      </div>
      <form-row>
        <form-group
          v-for="service in openCareerItemIds"
          :key="`${service.counselor_id}-${service.counselling_service_id}`"
          class="col-md-3 col-sm-6"
        >
          <template slot="form-check">
            <div class="form-check">
              <check-input
                v-model="appointment.appointment_services"
                :label="service.counselling_service_name"
                :type="counselor.counselor_multiple_enable ? 'checkbox' : 'radio'"
                :value="service.counselling_service_id"
                :name="`${counselor.counselling_type}-counselling-services-${counselor.counselor_id}`"
              />
            </div>
          </template>
        </form-group>
      </form-row>
    </div>
    <div class="consulting_apply_area">
      <div class="detail_block float-left">
        <slot />
      </div>
      <div class="row justify-content-end">
        <button-wrapper
          class="btn--wide mr-4"
          color="darken_blue"
          :disabled="!isAnyTimeSlotSelected || appointment.appointment_services.length < 1 || !isResidentStart || isResidentClose || currentAppointmentTimeSlot == null"
          @click.prevent="enrollCounselling"
        >
          {{ button_wrapper_text }}
        </button-wrapper>
      </div>
    </div>
    <student-enroll-counselling-modal
      v-if="isOpenEnrollModal"
      modal-title="請確認報名職涯諮詢"
      show-privacy-policy
      :type="titleEn"
      :is-modal-open="isOpenEnrollModal"
      :appointment="appointment"
      :group-list="group_lists"
      @modal:close="closeEnrollModal"
      @submit="submitEnrollment"
    />
    <redirect-login-page-modal
      v-if="isOpenRedirectModal"
      auth-type="student"
      :is-modal-open="isOpenRedirectModal"
      @modal:close="closeRedirectModal"
    />
  </form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import FormSelect from '~components/common/form/Select'
import FormGroup from '~components/common/form/Group'
import InputGroup from '~components/common/form/input/Group'
import FormRow from '~components/common/form/Row'
import CheckInput from '~components/common/form/input/Check'
import StudentEnrollCounsellingModal from '~components/common/modal/StudentEnrollCounselling'
import RedirectLoginPageModal from '~components/common/modal/RedirectLoginPage'
import ButtonWrapper from '~components/common/buttons'
import moment from 'moment'
export default {
  name: 'CareerCounsellingCardForm',
  components: {
    FormSelect,
    FormGroup,
    FormRow,
    InputGroup,
    CheckInput,
    ButtonWrapper,
    StudentEnrollCounsellingModal,
    RedirectLoginPageModal
  },
  props: {
    counselor: {
      type: Object,
      required: true
    },
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      appointment: {
        counselor_name: this.counselor.counselor_name,
        appointment_services: [],
        counselor_group_name: '',
        counselor_group_limit: ''
      },
      isOpenEnrollModal: false,
      isOpenRedirectModal: false,
      currentAppointmentDate: null,
      currentAppointmentTimeSlot: null,
      resident_start_date: '',
      resident_end_date: '',
      show_status: 0,
      limit: 0,
      students_count: 0,
      button_wrapper_text: '報名',
      open_item_ids: [],
      group_lists: ''
    }
  },
  computed: {
    ...mapGetters('pages/career-counselling', [
      'servicesGetter',
      'currentCounselorGroupListsGetter'
    ]),
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isStudentGetter'
    ]),
    isAnyTimeSlotSelected () {
      return Boolean(this.times.length && Object.keys(this.appointment).includes('appointment_time_slot'))
    },
    isResidentClose () {
      return Boolean(this.resident_end_date < moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    isResidentStart () {
      return Boolean(this.resident_start_date < moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    dates () {
      if (!Object.keys(this.counselor).length || !this.counselor.available_appointment_time_slots.length) {
        return []
      }
      const unique = Array.from(new Set(this.counselor.available_appointment_time_slots.map((slot) => slot.appointment_date)))

      const dateOptions = unique.map(date => {
        return {
          name: date,
          value: date
        }
      })
      return dateOptions
    },
    times () {
      if (!Object.keys(this.counselor).length || !this.counselor.available_appointment_time_slots.length) {
        return []
      }

      const availableTimeSlots = this.counselor.available_appointment_time_slots.filter((slot) => slot.appointment_date === this.currentAppointmentDate)
      if (!availableTimeSlots.length) {
        return []
      }
      return availableTimeSlots.map((slot) => {
        return {
          name: `${this.$moment(`${slot.appointment_date} ${slot.appointment_time_start}`).format('HH:mm')}~${this.$moment(`${slot.appointment_date} ${slot.appointment_time_end}`).format('HH:mm')}`,
          value: slot.appointment_counselor_id
        }
      })
    },
    openCareerItemIds () {
      return this.open_item_ids
    }
  },
  watch: {
    counselor (value) {
      this.appointment = Object.assign({}, this.appointment, {
        counselor_name: value.counselor_name
      })
    }
  },
  async created () {
    if (this.counselor.counselor_group_Id != null) {
      if (this.counselor.counselling_type === 'career-counselors') {
        await this.getAllMentorWithSameGroupById({
          career: 'career-counselors',
          group_id: this.counselor.counselor_group_Id
        })
        this.group_lists = this.currentCounselorGroupListsGetter.join(',')
      } else {
        await this.getAllMentorWithSameGroupById({
          career: 'industry-mentors',
          group_id: this.counselor.counselor_group_Id
        })
        this.group_lists = this.currentCounselorGroupListsGetter.join(',')
      }
    } else {
      this.group_lists = '無所屬群組'
    }
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    ...mapActions('pages/students', [
      'createStudentCareerCounsellingEnrollment'
    ]),
    ...mapActions('pages/career-counselling', [
      'getAllMentorWithSameGroupById'
    ]),
    appointmentDateSelected (date) {
      this.currentAppointmentDate = date.value
      this.currentAppointmentTimeSlot = null
      this.appointment.appointment_services = []
    },
    appointmentTimeSlotSelected (timeSlot) {
      this.currentAppointmentTimeSlot = timeSlot
      this.appointment.appointment_services = []

      this.appointment = Object.assign({}, this.appointment, {
        appointment_time_slot: this.counselor.available_appointment_time_slots.find((slot) => slot.appointment_counselor_id === timeSlot.value),
        time_slot_formated: timeSlot.name
      })
      this.$emit('time-slot-change', timeSlot)

      let residentStartDate
      let residentEndDate
      this.counselor.counselling_notice.forEach((value) => {
        if (value.id === timeSlot.value) {
		  this.resident_start_date = value.resident_start;
		  this.resident_end_date = value.resident_end;
		  this.show_status = value.show_status;
		  this.limit = value.limit;
		  this.students_count = value.students_count;
        }
      })
      this.open_item_ids = this.GetOpenItemIdsArray(this.counselor.counselor_open_item_ids)

      if (!this.isResidentStart && !this.isResidentClose) {
        this.button_wrapper_text = '尚未開放報名'
      } else if (this.isResidentClose) {
        this.button_wrapper_text = '報名已截止'
      } else {
        this.button_wrapper_text = '報名'
      }
    },
    enrollCounselling () {
      this.appointment.counselor_group_name = this.counselor.counselor_group_name != null ? this.counselor.counselor_group_name : '無所屬群組'
      this.appointment.counselor_group_limit = this.counselor.counselor_group_limit != null ? this.counselor.counselor_group_limit : '無限制'
      if (this.isStudentGetter) {
        this.isOpenEnrollModal = true
      } else {
        sessionStorage.setItem('route',window.location.href)
        this.isOpenRedirectModal = true
      }
      this.toggleModal(true)
    },
    closeEnrollModal () {
      this.isOpenEnrollModal = false
      this.toggleModal(false)
    },
    closeRedirectModal () {
      this.isOpenRedirectModal = false
      this.toggleModal(false)
    },
    submitEnrollment (appointment) {
      const request = { appointment }
      if (this.counselor.counselling_type === 'career-counselors') {
        request.type = 'career-counselors'
      } else {
        request.type = 'industry-mentors'
      }
      this.createStudentCareerCounsellingEnrollment(request)
      this.$router.push({
        path: '/students',
        query: {
          tab: '活動紀錄',
          sub: this.titleCh
        }
      })
    },
    GetOpenItemIdsArray (openItemIds) {
      if (openItemIds == null) {
        return []
      }
      let temp = []
      let OIIds = openItemIds.slice(1, -1)
      OIIds = OIIds.replaceAll(' ', '')
      OIIds = OIIds.split(',').map(function (num) {
        return parseInt(num)
      })
      this.servicesGetter.forEach(function (obj) {
        if (OIIds.includes(obj.counselling_service_id)) {
          temp.push(obj)
        }
      })
      return temp
    }
  }
}
</script>
<style lang="scss" scoped>
.date_block {
    margin-right: 3rem;
}

@media all and (max-width: 767px) {
    .date_block {
        margin-right: 0;
    }
}
</style>
